import { FunctionComponent } from 'react';
import styled from '@emotion/styled';
import { Switch, styled as muiStyled } from '@material-ui/core';
import { useDataTrackingEnabled } from 'core/hooks/useDataTrackingEnabled';

// override default Switch which has margin: 17px applied per design
const SwitchNoMargins = muiStyled(Switch)(() => ({
  margin: 0,
}));

// to vertically align accordion row content
const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

// to position switch at the far right end
const RowContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
`;

export const DataTrackingPolicyRow: FunctionComponent<{ heading: string }> = ({ heading }) => {
  const [dataTrackingEnabled, setDataTrackingEnabled] = useDataTrackingEnabled();

  return (
    <Container>
      {heading}
      <RowContainer>
        <SwitchNoMargins
          name="Data Tracking"
          checked={dataTrackingEnabled}
          onChange={(_, value) => {
            setDataTrackingEnabled(value);
          }}
          onClick={(e) => {
            // prevent expanding of accordion on toggle
            e.stopPropagation();
          }}
        />
      </RowContainer>
    </Container>
  );
};
